import "chartjs-chart-box-and-violin-plot/build/Chart.BoxPlot.js";
import * as ChartAnnotation from 'chartjs-plugin-annotation';
import { generateChart, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

const BoxPlot = generateChart("boxplot", "boxplot");


export default {
  extends: BoxPlot,
  mixins: [reactiveProp],
  plugins: [ChartAnnotation],
  props: {
    'options': Object,
    'height': {
      default: 150,
      type: Number,
    }
  },
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options);
  }
};

